import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { useThemeMode } from '../../theme/ThemeProvider';
import './Fireworks.css';

const { Title } = Typography;

const Fireworks = ({ show, onComplete, courseName }) => {
  const { mode } = useThemeMode();
  const [particles, setParticles] = useState([]);

// Function để phát âm thanh applause
const playFireworkSound = () => {
  try {
    const audio = new Audio('./applause.mp3');
    audio.volume = 0.7; // Set âm lượng 70%
    audio.currentTime = 0; // Bắt đầu từ đầu file

    // Phát âm thanh
    audio.play().catch(error => {
      console.log('Audio playback failed:', error);
    });

    // Dừng âm thanh sau 4 giây
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, 4000);

  } catch (error) {
    console.log('Audio not supported:', error);
  }
};


  useEffect(() => {
    if (show) {
      // Tạo nhiều đợt pháo hoa
      const createFireworks = () => {
        const newParticles = [];

        // Tạo 5 đợt pháo hoa với thời gian khác nhau
        for (let i = 0; i < 5; i++) {
          setTimeout(() => {
            // Phát âm thanh pháo hoa
            playFireworkSound();

            const fireworkParticles = [];
            // Premium color palette: Gold, Sunset, Vibrant Teal, Electric Purple
            const colors = mode === 'dark' 
              ? ['#FFD700', '#FFA500', '#FF4500', '#00CED1', '#9400D3', '#FF1493']
              : ['#D4AF37', '#FF8C00', '#E0115F', '#008B8B', '#8A2BE2', '#C71585'];
            const centerX = Math.random() * 80 + 10; // 10% to 90% of screen width
            const centerY = Math.random() * 40 + 20; // 20% to 60% of screen height

            // Tạo 20 hạt cho mỗi đợt pháo hoa
            for (let j = 0; j < 20; j++) {
              const angle = (j / 20) * 2 * Math.PI;
              const velocity = Math.random() * 100 + 50;
              const color = colors[Math.floor(Math.random() * colors.length)];

              fireworkParticles.push({
                id: `${i}-${j}`,
                x: centerX,
                y: centerY,
                vx: Math.cos(angle) * velocity,
                vy: Math.sin(angle) * velocity,
                color: color,
                life: 1,
                delay: i * 300 // Delay giữa các đợt pháo hoa
              });
            }

            setParticles(prev => [...prev, ...fireworkParticles]);
          }, i * 300);
        }
      };

      createFireworks();

      // Tự động ẩn sau 6 giây
      const timer = setTimeout(() => {
        setParticles([]);
        if (onComplete) {
          onComplete();
        }
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [show, onComplete, mode]);

  if (!show) return null;

  return (
    <div className={`fireworks-container ${mode}`}>
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="firework-particle"
          style={{
            '--start-x': `${particle.x}%`,
            '--start-y': `${particle.y}%`,
            '--end-x': `${particle.x + particle.vx / 10}%`,
            '--end-y': `${particle.y + particle.vy / 10}%`,
            '--color': particle.color,
            '--delay': `${particle.delay}ms`
          }}
        />
      ))}

      {/* Thêm text chúc mừng */}
      <div className="congratulations-text">
        <Title level={3} style={{ fontWeight: 'bold', marginBottom: 16 }}>
           Congratulations! 
        </Title>
        <Title level={5}>
          {courseName && `You have completed the course: ${courseName}!`}
        </Title>
      </div>
    </div>
  );
};

export default Fireworks;
